// extracted by css-extract-rspack-plugin
export default {"priceSection":"priceSection-eqL1im","errorIcon":"errorIcon-CGwgqv","loader":"loader-Bf_7ju"};